






















import Vue from 'vue'
export default Vue.extend({
  name: 'roster-sort',
  props: {
    pilots: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    sorts: [
      { name: 'Created', field: '' },
      { name: 'Callsign', field: 'Callsign' },
      { name: 'Name', field: 'Name' },
      { name: 'License Level', field: 'Level' },
    ],
  }),
  methods: {
    sortBy(field: string, direction: string) {
      const vm = this as any
      vm.$emit('sort', [field, direction])
    },
  },
})
